import { clsx } from 'clsx'
import { Translate } from 'common'
import { ReactElement, useMemo } from 'react'
import { useSelector } from 'react-redux'
import Select, { OptionProps, SingleValueProps, components } from 'react-select'
import { RootState } from 'store'
import { Address } from '../../../../src/api/user/interfaces'
import styles from '../../../../src/features/search/VehicleSearch/components/VehicleQuickFind/index.module.scss'
import { getVehicleOrderFormData } from '../store/cartSelectors'
import { Vehicle } from 'src/store/models/Vehicles'

interface IShipToDropdown {
  onSelect: (address: string) => void
  vehicle: Vehicle
}

const AddressOption = (props: OptionProps<Address>) => {
  const { line1, line3, city, postalCode } = props.data
  return (
    <components.Option {...props}>
      <span className={styles.cityName_class}>{line3}</span>
      <span>{[line1, city, postalCode].join(', ')}</span>
    </components.Option>
  )
}

const AddressSingleValue = (props: SingleValueProps<Address>) => {
  const { line1, line3, city, postalCode } = props.data
  return (
    <components.SingleValue {...props}>
      <span>{`${line3} - ${[line1, city, postalCode].join(', ')}`}</span>
    </components.SingleValue>
  )
}

const selectComponents = {
  Option: AddressOption,
  SingleValue: AddressSingleValue,
}

export const ShipToDropdown = ({
  onSelect,
  vehicle,
}: IShipToDropdown): ReactElement => {
  const options = useSelector<RootState, Address[]>(
    (state) => state.cart.addresses
  )

  const shipToAddress = useSelector(
    (state: RootState) => getVehicleOrderFormData(state, vehicle).shipToAddress
  )

  const selectedOption = useMemo(
    () => options.find((o) => o.id === shipToAddress) ?? null,
    [options, shipToAddress]
  )

  return (
    <div className={styles.shipToContainer_class}>
      <span className={styles.shipToLabel_class}>{Translate('shipTo')}</span>
      <Select
        closeMenuOnSelect={true}
        components={selectComponents}
        placeholder={Translate('selectPlaceholder')}
        classNames={{
          control: (state) =>
            state.isFocused
              ? clsx(styles.controlClass_sta, styles.focused)
              : styles.controlClass_sta,
          indicatorSeparator: () => styles.indicatorSeparator_class,
          option: (state) =>
            state.data.id === selectedOption?.id
              ? clsx(styles.option_class_sta, styles.selected_option_class_sta)
              : styles.option_class_sta,
        }}
        onChange={(value) => onSelect(value.id)}
        value={selectedOption}
        options={options}
        menuPosition="fixed"
        isMulti={false}
      />
    </div>
  )
}
